export function H1({ className, children, ...props }: Props) {
  return (
    <h1
      {...props}
      className={
        'text-gray  gotham font-medium text-5xl' +
        (className ? ` ${className}` : '')
      }
    >
      {children}
    </h1>
  )
}

export function H2({ className, children, ...props }: Props) {
  return (
    <h2
      {...props}
      className={
        'text-gray  gotham font-medium text-2xl' +
        (className ? ` ${className}` : '')
      }
    >
      {children}
    </h2>
  )
}

type Props = any

export function SubHeadline({ className, children, ...props }: Props) {
  return (
    <h2
      {...props}
      className={
        'text-left sm:text-center text-gray uppercase text-sm sm:text-base tracking-wider gotham opacity-50 font-medium' +
        (className ? ` ${className}` : '')
      }
    >
      {children}
    </h2>
  )
}

export function SmallItem({ className, children, ...props }: Props) {
  return (
    <h2
      {...props}
      className={
        'text-gray opacity-60 gotham font-medium' +
        (className ? ` ${className}` : '')
      }
      style={{
        fontSize: '13px',
      }}
    >
      {children}
    </h2>
  )
}

export function Item({
  className,
  children,
  subtle,
  ...props
}: Props & { subtle?: boolean }) {
  return (
    <h2
      {...props}
      className={
        'text-gray  gotham font-medium text-lg' +
        (className ? ` ${className}` : '') +
        (subtle ? ' opacity-60' : '')
      }
    >
      {children}
    </h2>
  )
}

export const Onboarding = {
  H1({ className, children, ...props }: Props) {
    return (
      <h1
        {...props}
        className={
          'text-left sm:text-center text-3xl sm:text-5xl mt-8 text-gray sm:leading-snug gotham font-medium ' +
          (className ? ` ${className}` : '')
        }
      >
        {children}
      </h1>
    )
  },
  H2({ className, children, ...props }: Props) {
    return (
      <h2
        {...props}
        className={
          'text-2xl sm:text-3xl text-blue leading-none mb-8 gotham font-medium ' +
          (className ? ` ${className}` : '')
        }
      >
        {children}
      </h2>
    )
  },
}

export const Blog = {
  H1({ className, children, ...props }: Props) {
    return (
      <h1
        {...props}
        className={
          'sm:text-center mb-10 text-4xl sm:text-6xl sm:mb-24 mt-8 sm:mt-8 text-gray sm:leading-snug gotham font-medium ' +
          (className ? ` ${className}` : '')
        }
      >
        {children}
      </h1>
    )
  },
}

export const Marketing = {
  H1: ({ className, children, ...props }: Props) => {
    return (
      <h1
        {...props}
        className={
          'text-left sm:text-center text-4xl sm:text-6xl text-bg-blue leading-tight gotham font-medium ' +
          (className ? ` ${className}` : '')
        }
      >
        {children}
      </h1>
    )
  },
  SubHeadline: ({ className, children, ...props }: Props) => {
    return (
      <h2
        {...props}
        className={
          'text-left sm:text-center mx-auto md:text-2xl text-lg text-gray opacity-60 sm:leading-snug gotham font-medium ' +
          (className ? ` ${className}` : '')
        }
      >
        {children}
      </h2>
    )
  },
  H2: ({ className, children, ...props }: Props) => {
    return (
      <h2
        {...props}
        className={
          'text-left sm:text-center text-gray gotham font-medium text-3xl sm:text-5xl leading-tight' +
          (className ? ` ${className}` : '')
        }
      >
        {children}
      </h2>
    )
  },
  H3: ({ className, children, ...props }: Props) => {
    return (
      <h3
        {...props}
        className={
          'text-gray gotham font-medium text-2xl sm:text-4xl leading-tight' +
          (className ? ` ${className}` : '')
        }
      >
        {children}
      </h3>
    )
  },
}

export function Label({
  className,
  children,
  ...props
}: Props & { subtle?: boolean }) {
  return (
    <div
      {...props}
      className={
        'text-gray uppercase gotham font-medium' +
        (className ? ` ${className}` : '')
      }
      style={{
        fontSize: 16,
      }}
    >
      {children}
    </div>
  )
}
